import axios from 'axios';
import axiosRetry from "axios-retry";
import applyAppTokenRefreshInterceptor from './axios.refresh_token.2';
// import React from "react";
import {userSignOutByTimeout} from "../actions";
import {store} from "../MainApp";
import {showBBNotification} from "./bbHelpers";


//**Updated API_URL for dev server to api-d.breachrisk.co per conversation with John, May 2023
// export const API_URL = `https://dev-apiv2.breachbits.co/`; //YOUR_API_URL HERE
export const API_URL = `https://api.breachrisk.co/`; //YOUR_API_URL HERE


export const apiClient = axios.create({
  baseURL: API_URL ,
  headers: {
    'Content-Type': 'application/json',
  }
});

/* setApiAuthBearer = (bearerValue)
*  used to set the Authorization header on the apiClient api.
*  Should be called upon a successful login, and any time a call fails for 401 reasons, since if the user reloads the page this value could be lost?
* TODO: Check it this should be called in cases where user has reloaded the app/page
* */
export const setApiAuthBearer = (bearerValue) => {
    // console.log("setApiAuthBearer is updating Authorization Bearer with ", bearerValue);
  apiClient.defaults.headers.common['Authorization'] = "Bearer " + bearerValue;
};

export const deleteApiAuthBearer = () => {
    console.log("deleteApiAuthBearer is deleting Authorization Bearer");

    delete apiClient.defaults.headers.common["Authorization"];
}

applyAppTokenRefreshInterceptor(apiClient);

// function isNetworkError(err) {
//     return !!err.isAxiosError && !err.response;
// }

const maxAxiosRetries = 3;

axiosRetry(apiClient, {
    retries: maxAxiosRetries,
    // retryDelay: axiosRetry.exponentialDelay,
    shouldResetTimeout: true,
    retryCondition: (error) => {
        console.warn(error);
        //don't show the config which could contain pw
        // console.log(error.config);
        console.log(error.request);
        console.log(error.response);
        console.log(error.code);
        console.log(error.status);
        if ((axiosRetry.isNetworkOrIdempotentRequestError(error) || error.code === 'ECONNABORTED') && error.status !== 427) {
            //if this is not the last retry, then show a message helping user know
            if(error.config["axios-retry"] && error.config["axios-retry"].retryCount < maxAxiosRetries) {
                if (error.code === 'ECONNABORTED') {
                    showBBNotification("INFO","Still Working...", null );
                } else {
                    showBBNotification("INFO","Retrying...", `There was a problem with your request, retrying. (${error.config.status ? error.config.status : error.code} ${error.config.url})` );
                }
            }
            return true
        } else {
            console.log("Above: retryCondition was called, but did not evaluate as needing a recall.");
            return false
        }
    },
});
// axiosRetry(apiClient, { retryDelay: axiosRetry.exponentialDelay});

//attempt to set the auth bearer from local storage, if it exists
const maybeAToken = JSON.parse(localStorage.getItem('token'));
if(maybeAToken){
    setApiAuthBearer(maybeAToken);
}

//forces a logout if the token is found to be expired
// TODO: validate that this works as expected
// response of 427 is sent when user refresh token is expired
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      // if (error.response && (error.response.status === 401 || error.response.status === 427)  && JSON.parse(localStorage.getItem('token'))) {
      if (error.response && (error.response.status === 427)  && JSON.parse(localStorage.getItem('token'))) {
            console.info("Detected 427 and what appears to be expired token. Signing user out by timeout.")
              store.dispatch(userSignOutByTimeout());
      } else { //continue with normal flow
          return error;
      }
    },
);
